import { handleLogout } from "../../Modules/Common/Auth";
import axiosPrivate from "./SetupAxios";

let isLoggingOut = false;

export const handleApiTokenError = (dispatch, request, error) => {
    if (
        !isLoggingOut &&
        typeof request === 'function' &&
        !request.toString().includes('logout') &&
        !request.toString().includes('login')
    ) {

        if (error?.response?.status === 401) {
            isLoggingOut = true;
            handleLogout(dispatch).finally(() => {
                isLoggingOut = false;
            });
        }
    }

};

const handleNetworkError = (dispatch, error) => {

    if (error.code === "ERR_NETWORK") {
        if (!error.response) error.response = {};
        error.response.data = { ...error.response.data, message: "Server not reachable"};
        error.response = { ...error.response, status:502};
    }
};

const normalizeToArray = (actions) =>
    actions == null ? [] : Array.isArray(actions) ? actions : [actions];

export const handleAsyncAction = async (
    dispatch,
    requestOrConfig,              // function OR config object
    successActions,
    failureActions,
    successData = null,
    client = axiosPrivate,         // can override with axiosPublic
    options = { handleTokenError: true, logErrors: true }
) => {
    try {
        let response;

        if (typeof requestOrConfig === "function") {
            response = await requestOrConfig();
        } else {
            const {
                method = "get",
                url,
                data = {},
                params = {},
                headers = {}
            } = requestOrConfig;

            response = await client.request({
                method,
                url,
                data,
                params,
                headers
            });
        }

        const responseData = successData ? response[successData] : response;

        // Axios puts the API JSON body on response.data; message lives there (not on the response root).
        const successEnvelope =
            response &&
            typeof response === 'object' &&
            typeof response.status === 'number' &&
            Object.prototype.hasOwnProperty.call(response, 'data')
                ? response.data
                : responseData;

        normalizeToArray(successActions).forEach((action, index) => {
            try {
                const payload = index === 0 ? response : responseData;

                const result = action(payload);

                if (typeof result === 'function') {
                    // Custom/thunk function
                    result({ dispatch, responseData, fullResponse: response });
                } else if (typeof result === 'object' && result.type) {
                    // Plain Redux action
                    dispatch(result);
                }

            } catch (error) {
            }
        });

        return {
            success: true,
            statusCode: response?.status || 200,
            status: mapStatusToType(response?.status || 200),
            message: successEnvelope?.message || "Request Succeeded",
            data: successEnvelope?.data ?? successEnvelope,
            meta: successEnvelope?.meta || null,
            errors: null
        };


    } catch (error) {
        //handleApiTokenError(dispatch, () => {}, error);
        if (options.handleTokenError !== false) {
            handleApiTokenError(dispatch, () => {}, error);
        }
        handleNetworkError(dispatch, error);
        //logApiError(error, requestOrConfig);
        if (options.logErrors !== false) {
            logApiError(error, requestOrConfig);
        }

        normalizeToArray(failureActions).forEach(action => {
            try {
                const result = action(error?.response);
                dispatch(result);
            } catch (error) {
            }
        });

        const parsedError = parseErrorResponse(error);

        return {
            success: false,
            statusCode: parsedError.statusCode,
            status: parsedError.status,
            message: parsedError.message,
            data: parsedError.data || null,
            errors: parsedError.errors,
        };
    }
};

const parseErrorResponse = (error) => {
    const response = error?.response || {};
    const data = response?.data || {};
    const statusCode = response.status || 500;
    const status = mapStatusToType(statusCode);

    return {
        statusCode,
        status,
        message: data.message || "Unexpected error occurred",
        errors: data.errors || {},
        data: data.data || {},
    };
};

const logApiError = (error, config, logger = console) => {
    const meta = {
        method: config?.method || "N/A",
        url: config?.url || "N/A",
        status: error?.response?.status,
        message: error?.response?.data?.message || error.message,
    };
    logger.error("API Error Log:", meta);
};

const mapStatusToType = (code) => {
    if (code >= 200 && code < 300) return "success";
    if ([400, 401, 403, 405, 422, 423].includes(code)) return "warning";
    if ([401, 403].includes(code)) return "error";
    if (code >= 500) return "error";
    return "info";
};